import dayjs from "dayjs";
import { ChatDataType, PanelDataType } from "../constant";
import { extractPatterns, cleanText, parseSuggestions } from "./chatParser";

const parseBotResponse = (answer) => {
  const patterns = extractPatterns(answer);
  const cleanedText = cleanText(answer);

  return {
    patterns,
    cleanedText,
  };
};

export const formatBotResponse = (
  answer,
  timestamp,
  showSuggestions = true
) => {
  const { patterns, cleanedText } = parseBotResponse(answer);
  const formattedResponse = [
    {
      type: ChatDataType.Text,
      bot: true,
      content: cleanedText,
      timestamp: timestamp,
    },
  ];

  if (showSuggestions && patterns.SUGGESTIONS) {
    formattedResponse.push({
      type: ChatDataType.Chips,
      bot: true,
      content: parseSuggestions(patterns.SUGGESTIONS),
    });
  }

  if (showSuggestions && patterns.SHOW_DATE_PICKER) {
    formattedResponse.push({
      type: ChatDataType.DateInput,
      bot: true,
      content: "",
    });
  }

  let weddingPlan = {};

  if (patterns.WeddingPlan) {
    try {
      const parsedWeddingPlan = JSON.parse(patterns.WeddingPlan);
      const parsedWeddingPlanTimeline =
        parsedWeddingPlan.timeline ||
        parsedWeddingPlan.pre_wedding_timeline ||
        null;
      const parsedWeddingPlanBudget = parsedWeddingPlan.budget || null;
      const parsedWeddingPlanEstimatedBudget =
        parsedWeddingPlan.estimated_budget || null;
      const parsedWeddingPlanVenues =
        parsedWeddingPlan.recommended_venues || null;
      const parsedExtraRecommendations =
        parsedWeddingPlan.extra_recommendations || null;
      const parsedKeyInfo = parsedWeddingPlan.key_info || null;

      if (parsedWeddingPlanTimeline) {
        weddingPlan[PanelDataType.Timeline] = parsedWeddingPlanTimeline;
      }

      if (parsedWeddingPlanBudget || parsedWeddingPlanEstimatedBudget) {
        weddingPlan[PanelDataType.Budget] =
          parsedWeddingPlanBudget || parsedWeddingPlanEstimatedBudget;
      }

      if (parsedWeddingPlanVenues && parsedWeddingPlanVenues.length > 0) {
        weddingPlan[PanelDataType.Venues] = parsedWeddingPlanVenues;
      }

      if (parsedExtraRecommendations && parsedExtraRecommendations.length > 0) {
        weddingPlan[PanelDataType.ExtraRecommendations] =
          parsedExtraRecommendations;
      }

      if (parsedKeyInfo) {
        weddingPlan[PanelDataType.KeyInfo] = parsedKeyInfo;
      }

      console.log({ parsedWeddingPlan, weddingPlan });
    } catch (error) {
      console.error("Error parsing wedding plan:", error);
    }
  }

  // Only keep weddingPlan if it has properties
  if (Object.keys(weddingPlan).length === 0) {
    weddingPlan = null;
  }

  return { formattedResponse, weddingPlan };
};

/**
 * Transform the format of the chat history to the json format used in the chatbot
 * @param {array<object>} chatHistory
 * @returns {array}
 */
export const formatChatHistory = (chatHistory) => {
  let formattedChatHistory = [];
  let weddingPlan = null;
  let lastDate = null;

  chatHistory.forEach((chat, index) => {
    // Extract date in 'YYYY-MM-DD' format
    const chatDate = dayjs(chat.timestamp);
    const dateKey = chatDate.format("YYYY-MM-DD"); // only use date to check if the date has changed

    // If the date has changed, add a date entry
    if (lastDate !== dateKey) {
      const formattedDate = chatDate.format("MMM D");
      formattedChatHistory.push({
        type: ChatDataType.Date,
        bot: false,
        content: formattedDate,
      });
      lastDate = dateKey;
    }

    // User prompt
    if (chat.prompt) {
      formattedChatHistory.push({
        type: ChatDataType.Text,
        bot: false,
        content: chat.prompt,
        timestamp: chat.timestamp,
      });
    }

    // Bot response
    const isLastChat = index === chatHistory.length - 1;
    const { formattedResponse, weddingPlan: newWeddingPlan } =
      formatBotResponse(chat.answer, chat.timestamp, isLastChat);
    formattedChatHistory.push(...formattedResponse);

    if (newWeddingPlan) {
      weddingPlan = newWeddingPlan;
    }
  });

  return { chatHistory: formattedChatHistory, weddingPlan };
};
